import { Injectable, Optional, Injector, Directive, Input, TemplateRef, ViewContainerRef, NgModule, Component } from '@angular/core';
import { Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';
import { Subject } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

var RouteInterceptorService = /** @class */ (function () {
    function RouteInterceptorService(router) {
        var _this = this;
        this.router = router;
        this._isPendingRouteSubject = new Subject();
        if (this.router) {
            router.events.subscribe(function (event) {
                _this.routerInterceptor(event);
            });
        }
    }
    Object.defineProperty(RouteInterceptorService.prototype, "isPendingRoute", {
        get: function () {
            return this._isPendingRouteSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    RouteInterceptorService.prototype.routerInterceptor = function (event) {
        if (event instanceof NavigationStart) {
            this.onRouteStart();
        }
        if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError) {
            this.onRouteDone();
        }
    };
    RouteInterceptorService.prototype.onRouteStart = function () {
        this._isPendingRouteSubject.next(true);
    };
    RouteInterceptorService.prototype.onRouteDone = function () {
        this._isPendingRouteSubject.next(false);
    };
    return RouteInterceptorService;
}());
RouteInterceptorService.decorators = [
    { type: Injectable },
];
RouteInterceptorService.ctorParameters = function () { return [
    { type: Router, decorators: [{ type: Optional },] },
]; };
var HttpObservableService = /** @class */ (function () {
    function HttpObservableService() {
        this._pendingRequestsCounter = 0;
        this._isPendingRequestsSubject = new Subject();
    }
    Object.defineProperty(HttpObservableService.prototype, "isPendingRequests", {
        get: function () {
            return this._isPendingRequestsSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HttpObservableService.prototype, "pendingRequests", {
        get: function () {
            return this._pendingRequestsCounter;
        },
        enumerable: true,
        configurable: true
    });
    HttpObservableService.prototype.onRequestStart = function () {
        this._pendingRequestsCounter++;
        if (this._pendingRequestsCounter === 1) {
            this._isPendingRequestsSubject.next(true);
        }
    };
    HttpObservableService.prototype.onRequestDone = function () {
        this._pendingRequestsCounter--;
        if (this._pendingRequestsCounter === 0) {
            this._isPendingRequestsSubject.next(false);
        }
    };
    return HttpObservableService;
}());
HttpObservableService.decorators = [
    { type: Injectable },
];
var HttpInterceptorService = /** @class */ (function () {
    function HttpInterceptorService(injector) {
        this.injector = injector;
        this.httpObservableService = injector.get(HttpObservableService);
    }
    HttpInterceptorService.prototype.intercept = function (request, next) {
        var _this = this;
        this.httpObservableService.onRequestStart();
        return next.handle(request).pipe(finalize(function () {
            _this.httpObservableService.onRequestDone();
        }));
    };
    return HttpInterceptorService;
}());
HttpInterceptorService.decorators = [
    { type: Injectable },
];
HttpInterceptorService.ctorParameters = function () { return [
    { type: Injector, },
]; };
function HttpInterceptorServiceFactory(injector) {
    return new HttpInterceptorService(injector);
}
var LoadingPageDirective = /** @class */ (function () {
    function LoadingPageDirective(httpObservableService, routeInterceptorService, templateRef, viewContainer) {
        this.httpObservableService = httpObservableService;
        this.routeInterceptorService = routeInterceptorService;
        this.templateRef = templateRef;
        this.viewContainer = viewContainer;
        this.hasView = false;
    }
    LoadingPageDirective.prototype.ngOnChanges = function (changes) {
        if (changes["mkLoadingPage"].currentValue) {
            this.mkLoadingPage = changes["mkLoadingPage"].currentValue;
        }
        if (changes["mkLoadingPage"].firstChange) {
            this.init();
        }
    };
    LoadingPageDirective.prototype.init = function () {
        var _this = this;
        if (!this.mkLoadingPage || this.mkLoadingPage.checkPendingHttp) {
            this.httpObservableService.isPendingRequests.subscribe(function (value) {
                _this.isPendingRequests = value;
                _this.isVisible();
            });
        }
        if (!this.mkLoadingPage || this.mkLoadingPage.checkPendingRoute) {
            this.routeInterceptorService.isPendingRoute.subscribe(function (value) {
                _this.isPendingRoute = value;
                _this.isVisible();
            });
        }
    };
    LoadingPageDirective.prototype.isVisible = function () {
        if (this.hasView && !this.isPendingRequests && !this.isPendingRoute) {
            this.viewContainer.clear();
            this.hasView = false;
        }
        else if (!this.hasView && (this.isPendingRequests || this.isPendingRoute)) {
            this.viewContainer.createEmbeddedView(this.templateRef);
            this.hasView = true;
        }
    };
    return LoadingPageDirective;
}());
LoadingPageDirective.decorators = [
    { type: Directive, args: [{
                selector: '[mkLoadingPage]',
            },] },
];
LoadingPageDirective.ctorParameters = function () { return [
    { type: HttpObservableService, },
    { type: RouteInterceptorService, },
    { type: TemplateRef, },
    { type: ViewContainerRef, },
]; };
LoadingPageDirective.propDecorators = {
    "mkLoadingPage": [{ type: Input },],
};
var HttpInterceptorServiceExistingProvider = {
    provide: HTTP_INTERCEPTORS,
    useExisting: HttpInterceptorService,
    multi: true
};
var ɵ0 = HttpInterceptorServiceFactory;
var LoadingPageModule = /** @class */ (function () {
    function LoadingPageModule() {
    }
    return LoadingPageModule;
}());
LoadingPageModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule,
                    HttpClientModule
                ],
                declarations: [
                    LoadingPageDirective
                ],
                exports: [
                    HttpClientModule,
                    LoadingPageDirective
                ],
                providers: [
                    RouteInterceptorService,
                    HttpObservableService,
                    HttpInterceptorServiceExistingProvider,
                    {
                        provide: HttpInterceptorService,
                        useFactory: ɵ0,
                        deps: [Injector]
                    }
                ]
            },] },
];
var ChasingDotsComponent = /** @class */ (function () {
    function ChasingDotsComponent() {
        this.colorOne = '#da4733';
        this.colorTwo = '#3b78e7';
    }
    return ChasingDotsComponent;
}());
ChasingDotsComponent.decorators = [
    { type: Component, args: [{
                selector: 'mk-chasing-dots',
                template: "\n    <div class=\"sk-chasing-dots\">\n      <div class=\"sk-child sk-dot1\" [style.background-color]=\"colorOne\"></div>\n      <div class=\"sk-child sk-dot2\" [style.background-color]=\"colorTwo\"></div>\n    </div>",
                styles: [".sk-chasing-dots{margin:40px auto;width:40px;height:40px;position:relative;text-align:center;-webkit-animation:2s linear infinite sk-chasingDotsRotate;animation:2s linear infinite sk-chasingDotsRotate}.sk-chasing-dots .sk-child{width:60%;height:60%;display:inline-block;position:absolute;top:0;border-radius:100%;-webkit-animation:2s ease-in-out infinite sk-chasingDotsBounce;animation:2s ease-in-out infinite sk-chasingDotsBounce}.sk-chasing-dots .sk-dot2{top:auto;bottom:0;-webkit-animation-delay:-1s;animation-delay:-1s}@-webkit-keyframes sk-chasingDotsRotate{100%{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes sk-chasingDotsRotate{100%{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@-webkit-keyframes sk-chasingDotsBounce{0%,100%{-webkit-transform:scale(0);transform:scale(0)}50%{-webkit-transform:scale(1);transform:scale(1)}}@keyframes sk-chasingDotsBounce{0%,100%{-webkit-transform:scale(0);transform:scale(0)}50%{-webkit-transform:scale(1);transform:scale(1)}}"]
            },] },
];
ChasingDotsComponent.propDecorators = {
    "colorOne": [{ type: Input },],
    "colorTwo": [{ type: Input },],
};
var ChasingDotsModule = /** @class */ (function () {
    function ChasingDotsModule() {
    }
    return ChasingDotsModule;
}());
ChasingDotsModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule
                ],
                declarations: [
                    ChasingDotsComponent,
                ],
                exports: [
                    ChasingDotsComponent
                ]
            },] },
];
var CircleComponent = /** @class */ (function () {
    function CircleComponent() {
        this.color = '#da4733';
    }
    return CircleComponent;
}());
CircleComponent.decorators = [
    { type: Component, args: [{
                selector: 'mk-circle',
                template: "\n    <div class=\"sk-circle\">\n      <div class=\"sk-circle1 sk-child\"><div [style.background-color]=\"color\"></div></div>\n      <div class=\"sk-circle2 sk-child\"><div [style.background-color]=\"color\"></div></div>\n      <div class=\"sk-circle3 sk-child\"><div [style.background-color]=\"color\"></div></div>\n      <div class=\"sk-circle4 sk-child\"><div [style.background-color]=\"color\"></div></div>\n      <div class=\"sk-circle5 sk-child\"><div [style.background-color]=\"color\"></div></div>\n      <div class=\"sk-circle6 sk-child\"><div [style.background-color]=\"color\"></div></div>\n      <div class=\"sk-circle7 sk-child\"><div [style.background-color]=\"color\"></div></div>\n      <div class=\"sk-circle8 sk-child\"><div [style.background-color]=\"color\"></div></div>\n      <div class=\"sk-circle9 sk-child\"><div [style.background-color]=\"color\"></div></div>\n      <div class=\"sk-circle10 sk-child\"><div [style.background-color]=\"color\"></div></div>\n      <div class=\"sk-circle11 sk-child\"><div [style.background-color]=\"color\"></div></div>\n      <div class=\"sk-circle12 sk-child\"><div [style.background-color]=\"color\"></div></div>\n    </div>",
                styles: [".sk-circle{margin:40px auto;width:40px;height:40px;position:relative}.sk-circle .sk-child{width:100%;height:100%;position:absolute;left:0;top:0}.sk-circle .sk-child>div{display:block;margin:0 auto;width:15%;height:15%;border-radius:100%;-webkit-animation:1.2s ease-in-out infinite both sk-circleBounceDelay;animation:1.2s ease-in-out infinite both sk-circleBounceDelay}.sk-circle .sk-circle2{-webkit-transform:rotate(30deg);transform:rotate(30deg)}.sk-circle .sk-circle3{-webkit-transform:rotate(60deg);transform:rotate(60deg)}.sk-circle .sk-circle4{-webkit-transform:rotate(90deg);transform:rotate(90deg)}.sk-circle .sk-circle5{-webkit-transform:rotate(120deg);transform:rotate(120deg)}.sk-circle .sk-circle6{-webkit-transform:rotate(150deg);transform:rotate(150deg)}.sk-circle .sk-circle7{-webkit-transform:rotate(180deg);transform:rotate(180deg)}.sk-circle .sk-circle8{-webkit-transform:rotate(210deg);transform:rotate(210deg)}.sk-circle .sk-circle9{-webkit-transform:rotate(240deg);transform:rotate(240deg)}.sk-circle .sk-circle10{-webkit-transform:rotate(270deg);transform:rotate(270deg)}.sk-circle .sk-circle11{-webkit-transform:rotate(300deg);transform:rotate(300deg)}.sk-circle .sk-circle12{-webkit-transform:rotate(330deg);transform:rotate(330deg)}.sk-circle .sk-circle2>div{-webkit-animation-delay:-1.1s;animation-delay:-1.1s}.sk-circle .sk-circle3>div{-webkit-animation-delay:-1s;animation-delay:-1s}.sk-circle .sk-circle4>div{-webkit-animation-delay:-.9s;animation-delay:-.9s}.sk-circle .sk-circle5>div{-webkit-animation-delay:-.8s;animation-delay:-.8s}.sk-circle .sk-circle6>div{-webkit-animation-delay:-.7s;animation-delay:-.7s}.sk-circle .sk-circle7>div{-webkit-animation-delay:-.6s;animation-delay:-.6s}.sk-circle .sk-circle8>div{-webkit-animation-delay:-.5s;animation-delay:-.5s}.sk-circle .sk-circle9>div{-webkit-animation-delay:-.4s;animation-delay:-.4s}.sk-circle .sk-circle10>div{-webkit-animation-delay:-.3s;animation-delay:-.3s}.sk-circle .sk-circle11>div{-webkit-animation-delay:-.2s;animation-delay:-.2s}.sk-circle .sk-circle12>div{-webkit-animation-delay:-.1s;animation-delay:-.1s}@-webkit-keyframes sk-circleBounceDelay{0%,100%,80%{-webkit-transform:scale(0);transform:scale(0)}40%{-webkit-transform:scale(1);transform:scale(1)}}@keyframes sk-circleBounceDelay{0%,100%,80%{-webkit-transform:scale(0);transform:scale(0)}40%{-webkit-transform:scale(1);transform:scale(1)}}"]
            },] },
];
CircleComponent.propDecorators = {
    "color": [{ type: Input },],
};
var CircleModule = /** @class */ (function () {
    function CircleModule() {
    }
    return CircleModule;
}());
CircleModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule
                ],
                declarations: [
                    CircleComponent,
                ],
                exports: [
                    CircleComponent
                ]
            },] },
];
var CubeGridComponent = /** @class */ (function () {
    function CubeGridComponent() {
        this.color = '#da4733';
    }
    return CubeGridComponent;
}());
CubeGridComponent.decorators = [
    { type: Component, args: [{
                selector: 'mk-cube-grid',
                template: "\n    <div class=\"sk-cube-grid\">\n      <div class=\"sk-cube sk-cube1\" [style.background-color]=\"color\"></div>\n      <div class=\"sk-cube sk-cube2\" [style.background-color]=\"color\"></div>\n      <div class=\"sk-cube sk-cube3\" [style.background-color]=\"color\"></div>\n      <div class=\"sk-cube sk-cube4\" [style.background-color]=\"color\"></div>\n      <div class=\"sk-cube sk-cube5\" [style.background-color]=\"color\"></div>\n      <div class=\"sk-cube sk-cube6\" [style.background-color]=\"color\"></div>\n      <div class=\"sk-cube sk-cube7\" [style.background-color]=\"color\"></div>\n      <div class=\"sk-cube sk-cube8\" [style.background-color]=\"color\"></div>\n      <div class=\"sk-cube sk-cube9\" [style.background-color]=\"color\"></div>\n    </div>",
                styles: [".sk-cube-grid{width:40px;height:40px;margin:40px auto}.sk-cube-grid .sk-cube{width:33.33%;height:33.33%;float:left;-webkit-animation:1.3s ease-in-out infinite sk-cubeGridScaleDelay;animation:1.3s ease-in-out infinite sk-cubeGridScaleDelay}.sk-cube-grid .sk-cube1{-webkit-animation-delay:.2s;animation-delay:.2s}.sk-cube-grid .sk-cube2{-webkit-animation-delay:.3s;animation-delay:.3s}.sk-cube-grid .sk-cube3{-webkit-animation-delay:.4s;animation-delay:.4s}.sk-cube-grid .sk-cube4{-webkit-animation-delay:.1s;animation-delay:.1s}.sk-cube-grid .sk-cube5{-webkit-animation-delay:.2s;animation-delay:.2s}.sk-cube-grid .sk-cube6{-webkit-animation-delay:.3s;animation-delay:.3s}.sk-cube-grid .sk-cube7{-webkit-animation-delay:0ms;animation-delay:0ms}.sk-cube-grid .sk-cube8{-webkit-animation-delay:.1s;animation-delay:.1s}.sk-cube-grid .sk-cube9{-webkit-animation-delay:.2s;animation-delay:.2s}@-webkit-keyframes sk-cubeGridScaleDelay{0%,100%,70%{-webkit-transform:scale3D(1,1,1);transform:scale3D(1,1,1)}35%{-webkit-transform:scale3D(0,0,1);transform:scale3D(0,0,1)}}@keyframes sk-cubeGridScaleDelay{0%,100%,70%{-webkit-transform:scale3D(1,1,1);transform:scale3D(1,1,1)}35%{-webkit-transform:scale3D(0,0,1);transform:scale3D(0,0,1)}}"]
            },] },
];
CubeGridComponent.propDecorators = {
    "color": [{ type: Input },],
};
var CubeGridModule = /** @class */ (function () {
    function CubeGridModule() {
    }
    return CubeGridModule;
}());
CubeGridModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule
                ],
                declarations: [
                    CubeGridComponent,
                ],
                exports: [
                    CubeGridComponent
                ]
            },] },
];
var DoubleBounceComponent = /** @class */ (function () {
    function DoubleBounceComponent() {
        this.colorOne = '#da4733';
        this.colorTwo = '#3b78e7';
    }
    return DoubleBounceComponent;
}());
DoubleBounceComponent.decorators = [
    { type: Component, args: [{
                selector: 'mk-double-bounce',
                template: "\n    <div class=\"sk-double-bounce\">\n      <div class=\"sk-child sk-double-bounce1\" [style.background-color]=\"colorOne\"></div>\n      <div class=\"sk-child sk-double-bounce2\" [style.background-color]=\"colorTwo\"></div>\n    </div>",
                styles: [".sk-double-bounce{width:40px;height:40px;position:relative;margin:40px auto}.sk-double-bounce .sk-child{width:100%;height:100%;border-radius:50%;opacity:.6;position:absolute;top:0;left:0;-webkit-animation:2s ease-in-out infinite sk-doubleBounce;animation:2s ease-in-out infinite sk-doubleBounce}.sk-double-bounce .sk-double-bounce2{-webkit-animation-delay:-1s;animation-delay:-1s}@-webkit-keyframes sk-doubleBounce{0%,100%{-webkit-transform:scale(0);transform:scale(0)}50%{-webkit-transform:scale(1);transform:scale(1)}}@keyframes sk-doubleBounce{0%,100%{-webkit-transform:scale(0);transform:scale(0)}50%{-webkit-transform:scale(1);transform:scale(1)}}"]
            },] },
];
DoubleBounceComponent.propDecorators = {
    "colorOne": [{ type: Input },],
    "colorTwo": [{ type: Input },],
};
var DoubleBounceModule = /** @class */ (function () {
    function DoubleBounceModule() {
    }
    return DoubleBounceModule;
}());
DoubleBounceModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule
                ],
                declarations: [
                    DoubleBounceComponent,
                ],
                exports: [
                    DoubleBounceComponent
                ]
            },] },
];
var FadingCircleComponent = /** @class */ (function () {
    function FadingCircleComponent() {
        this.color = '#da4733';
    }
    return FadingCircleComponent;
}());
FadingCircleComponent.decorators = [
    { type: Component, args: [{
                selector: 'mk-fading-circle',
                template: "\n    <div class=\"sk-fading-circle\">\n      <div class=\"sk-circle1 sk-circle\"><div [style.background-color]=\"color\"></div></div>\n      <div class=\"sk-circle2 sk-circle\"><div [style.background-color]=\"color\"></div></div>\n      <div class=\"sk-circle3 sk-circle\"><div [style.background-color]=\"color\"></div></div>\n      <div class=\"sk-circle4 sk-circle\"><div [style.background-color]=\"color\"></div></div>\n      <div class=\"sk-circle5 sk-circle\"><div [style.background-color]=\"color\"></div></div>\n      <div class=\"sk-circle6 sk-circle\"><div [style.background-color]=\"color\"></div></div>\n      <div class=\"sk-circle7 sk-circle\"><div [style.background-color]=\"color\"></div></div>\n      <div class=\"sk-circle8 sk-circle\"><div [style.background-color]=\"color\"></div></div>\n      <div class=\"sk-circle9 sk-circle\"><div [style.background-color]=\"color\"></div></div>\n      <div class=\"sk-circle10 sk-circle\"><div [style.background-color]=\"color\"></div></div>\n      <div class=\"sk-circle11 sk-circle\"><div [style.background-color]=\"color\"></div></div>\n      <div class=\"sk-circle12 sk-circle\"><div [style.background-color]=\"color\"></div></div>\n    </div>",
                styles: [".sk-fading-circle{margin:40px auto;width:40px;height:40px;position:relative}.sk-fading-circle .sk-circle{width:100%;height:100%;position:absolute;left:0;top:0}.sk-fading-circle .sk-circle>div{content:'';display:block;margin:0 auto;width:15%;height:15%;border-radius:100%;-webkit-animation:1.2s ease-in-out infinite both sk-circleFadeDelay;animation:1.2s ease-in-out infinite both sk-circleFadeDelay}.sk-fading-circle .sk-circle2{-webkit-transform:rotate(30deg);transform:rotate(30deg)}.sk-fading-circle .sk-circle3{-webkit-transform:rotate(60deg);transform:rotate(60deg)}.sk-fading-circle .sk-circle4{-webkit-transform:rotate(90deg);transform:rotate(90deg)}.sk-fading-circle .sk-circle5{-webkit-transform:rotate(120deg);transform:rotate(120deg)}.sk-fading-circle .sk-circle6{-webkit-transform:rotate(150deg);transform:rotate(150deg)}.sk-fading-circle .sk-circle7{-webkit-transform:rotate(180deg);transform:rotate(180deg)}.sk-fading-circle .sk-circle8{-webkit-transform:rotate(210deg);transform:rotate(210deg)}.sk-fading-circle .sk-circle9{-webkit-transform:rotate(240deg);transform:rotate(240deg)}.sk-fading-circle .sk-circle10{-webkit-transform:rotate(270deg);transform:rotate(270deg)}.sk-fading-circle .sk-circle11{-webkit-transform:rotate(300deg);transform:rotate(300deg)}.sk-fading-circle .sk-circle12{-webkit-transform:rotate(330deg);transform:rotate(330deg)}.sk-fading-circle .sk-circle2>div{-webkit-animation-delay:-1.1s;animation-delay:-1.1s}.sk-fading-circle .sk-circle3>div{-webkit-animation-delay:-1s;animation-delay:-1s}.sk-fading-circle .sk-circle4>div{-webkit-animation-delay:-.9s;animation-delay:-.9s}.sk-fading-circle .sk-circle5>div{-webkit-animation-delay:-.8s;animation-delay:-.8s}.sk-fading-circle .sk-circle6>div{-webkit-animation-delay:-.7s;animation-delay:-.7s}.sk-fading-circle .sk-circle7>div{-webkit-animation-delay:-.6s;animation-delay:-.6s}.sk-fading-circle .sk-circle8>div{-webkit-animation-delay:-.5s;animation-delay:-.5s}.sk-fading-circle .sk-circle9>div{-webkit-animation-delay:-.4s;animation-delay:-.4s}.sk-fading-circle .sk-circle10>div{-webkit-animation-delay:-.3s;animation-delay:-.3s}.sk-fading-circle .sk-circle11>div{-webkit-animation-delay:-.2s;animation-delay:-.2s}.sk-fading-circle .sk-circle12>div{-webkit-animation-delay:-.1s;animation-delay:-.1s}@-webkit-keyframes sk-circleFadeDelay{0%,100%,39%{opacity:0}40%{opacity:1}}@keyframes sk-circleFadeDelay{0%,100%,39%{opacity:0}40%{opacity:1}}"]
            },] },
];
FadingCircleComponent.propDecorators = {
    "color": [{ type: Input },],
};
var FadingCircleModule = /** @class */ (function () {
    function FadingCircleModule() {
    }
    return FadingCircleModule;
}());
FadingCircleModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule
                ],
                declarations: [
                    FadingCircleComponent,
                ],
                exports: [
                    FadingCircleComponent
                ]
            },] },
];
var FoldingCubeComponent = /** @class */ (function () {
    function FoldingCubeComponent() {
        this.color = '#da4733';
    }
    return FoldingCubeComponent;
}());
FoldingCubeComponent.decorators = [
    { type: Component, args: [{
                selector: 'mk-folding-cube',
                template: "\n    <div class=\"sk-folding-cube\">\n      <div class=\"sk-cube1 sk-cube\"><div [style.background-color]=\"color\"></div></div>\n      <div class=\"sk-cube2 sk-cube\"><div [style.background-color]=\"color\"></div></div>\n      <div class=\"sk-cube4 sk-cube\"><div [style.background-color]=\"color\"></div></div>\n      <div class=\"sk-cube3 sk-cube\"><div [style.background-color]=\"color\"></div></div>\n    </div>",
                styles: [".sk-folding-cube{margin:40px auto;width:40px;height:40px;position:relative;-webkit-transform:rotateZ(45deg);transform:rotateZ(45deg)}.sk-folding-cube .sk-cube{float:left;width:50%;height:50%;position:relative;-webkit-transform:scale(1.1);transform:scale(1.1)}.sk-folding-cube .sk-cube>div{content:'';position:absolute;top:0;left:0;width:100%;height:100%;-webkit-animation:2.4s linear infinite both sk-foldCubeAngle;animation:2.4s linear infinite both sk-foldCubeAngle;-webkit-transform-origin:100% 100%;transform-origin:100% 100%}.sk-folding-cube .sk-cube2{-webkit-transform:scale(1.1) rotateZ(90deg);transform:scale(1.1) rotateZ(90deg)}.sk-folding-cube .sk-cube3{-webkit-transform:scale(1.1) rotateZ(180deg);transform:scale(1.1) rotateZ(180deg)}.sk-folding-cube .sk-cube4{-webkit-transform:scale(1.1) rotateZ(270deg);transform:scale(1.1) rotateZ(270deg)}.sk-folding-cube .sk-cube2>div{-webkit-animation-delay:.3s;animation-delay:.3s}.sk-folding-cube .sk-cube3>div{-webkit-animation-delay:.6s;animation-delay:.6s}.sk-folding-cube .sk-cube4>div{-webkit-animation-delay:.9s;animation-delay:.9s}@-webkit-keyframes sk-foldCubeAngle{0%,10%{-webkit-transform:perspective(140px) rotateX(-180deg);transform:perspective(140px) rotateX(-180deg);opacity:0}25%,75%{-webkit-transform:perspective(140px) rotateX(0);transform:perspective(140px) rotateX(0);opacity:1}100%,90%{-webkit-transform:perspective(140px) rotateY(180deg);transform:perspective(140px) rotateY(180deg);opacity:0}}@keyframes sk-foldCubeAngle{0%,10%{-webkit-transform:perspective(140px) rotateX(-180deg);transform:perspective(140px) rotateX(-180deg);opacity:0}25%,75%{-webkit-transform:perspective(140px) rotateX(0);transform:perspective(140px) rotateX(0);opacity:1}100%,90%{-webkit-transform:perspective(140px) rotateY(180deg);transform:perspective(140px) rotateY(180deg);opacity:0}}"]
            },] },
];
FoldingCubeComponent.propDecorators = {
    "color": [{ type: Input },],
};
var FoldingCubeModule = /** @class */ (function () {
    function FoldingCubeModule() {
    }
    return FoldingCubeModule;
}());
FoldingCubeModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule
                ],
                declarations: [
                    FoldingCubeComponent,
                ],
                exports: [
                    FoldingCubeComponent
                ]
            },] },
];
var MaterialbarComponent = /** @class */ (function () {
    function MaterialbarComponent() {
        this.colorOne = '#da4733';
        this.colorTwo = '#3b78e7';
        this.colorThree = '#fdba2c';
    }
    return MaterialbarComponent;
}());
MaterialbarComponent.decorators = [
    { type: Component, args: [{
                selector: 'mk-material-bar',
                template: "\n  <div class=\"material-bar\">\n    <div class=\"bar\" [style.background-color]=\"colorOne\"></div>\n    <div class=\"bar\" [style.background-color]=\"colorTwo\"></div>\n    <div class=\"bar\" [style.background-color]=\"colorThree\"></div>\n  </div>",
                styles: [".material-bar{position:relative;width:100%;height:4px;background-color:#fdba2c}.bar{content:\"\";display:inline;position:absolute;width:0;height:100%;left:50%;text-align:center}.bar:nth-child(1){-webkit-animation:3s linear infinite loading;animation:3s linear infinite loading}.bar:nth-child(2){-webkit-animation:3s linear 1s infinite loading;animation:3s linear 1s infinite loading}.bar:nth-child(3){-webkit-animation:3s linear 2s infinite loading;animation:3s linear 2s infinite loading}@-webkit-keyframes loading{from{left:50%;width:0;z-index:100}33.3333%{left:0;width:100%;z-index:10}to{left:0;width:100%}}@keyframes loading{from{left:50%;width:0;z-index:100}33.3333%{left:0;width:100%;z-index:10}to{left:0;width:100%}}"]
            },] },
];
MaterialbarComponent.propDecorators = {
    "colorOne": [{ type: Input },],
    "colorTwo": [{ type: Input },],
    "colorThree": [{ type: Input },],
};
var MaterialBarModule = /** @class */ (function () {
    function MaterialBarModule() {
    }
    return MaterialBarModule;
}());
MaterialBarModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule
                ],
                declarations: [
                    MaterialbarComponent,
                ],
                exports: [
                    MaterialbarComponent
                ]
            },] },
];
var PulseComponent = /** @class */ (function () {
    function PulseComponent() {
        this.color = '#da4733';
    }
    return PulseComponent;
}());
PulseComponent.decorators = [
    { type: Component, args: [{
                selector: 'mk-pulse',
                template: "<div class=\"sk-spinner sk-spinner-pulse\" [style.background-color]=\"color\"></div>",
                styles: [".sk-spinner-pulse{width:40px;height:40px;margin:40px auto;background-color:#333;border-radius:100%;-webkit-animation:1s ease-in-out infinite sk-pulseScaleOut;animation:1s ease-in-out infinite sk-pulseScaleOut}@-webkit-keyframes sk-pulseScaleOut{0%{-webkit-transform:scale(0);transform:scale(0)}100%{-webkit-transform:scale(1);transform:scale(1);opacity:0}}@keyframes sk-pulseScaleOut{0%{-webkit-transform:scale(0);transform:scale(0)}100%{-webkit-transform:scale(1);transform:scale(1);opacity:0}}"]
            },] },
];
PulseComponent.propDecorators = {
    "color": [{ type: Input },],
};
var PulseModule = /** @class */ (function () {
    function PulseModule() {
    }
    return PulseModule;
}());
PulseModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule
                ],
                declarations: [
                    PulseComponent,
                ],
                exports: [
                    PulseComponent
                ]
            },] },
];
var SlidingBarComponent = /** @class */ (function () {
    function SlidingBarComponent() {
        this.colorOne = '#ddd';
        this.colorTwo = '#3c8dbc';
    }
    return SlidingBarComponent;
}());
SlidingBarComponent.decorators = [
    { type: Component, args: [{
                selector: 'mk-sliding-bar',
                template: "<div class=\"sliding-bar\" [style.background-color]=\"colorOne\"><div [style.background-color]=\"colorTwo\"></div></div>",
                styles: [".sliding-bar{height:4px;width:100%;position:relative;overflow:hidden}.sliding-bar>div{display:block;position:absolute;content:\"\";left:-200px;width:200px;height:4px;background-color:#2980b9;-webkit-animation:2s linear infinite loading;animation:2s linear infinite loading}@-webkit-keyframes loading{from{left:-200px;width:30%}50%{width:30%}70%{width:70%}80%{left:50%}95%{left:120%}to{left:100%}}@keyframes loading{from{left:-200px;width:30%}50%{width:30%}70%{width:70%}80%{left:50%}95%{left:120%}to{left:100%}}"]
            },] },
];
SlidingBarComponent.propDecorators = {
    "colorOne": [{ type: Input },],
    "colorTwo": [{ type: Input },],
};
var SlidingBarModule = /** @class */ (function () {
    function SlidingBarModule() {
    }
    return SlidingBarModule;
}());
SlidingBarModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule
                ],
                declarations: [
                    SlidingBarComponent,
                ],
                exports: [
                    SlidingBarComponent
                ]
            },] },
];
var ThreeBounceComponent = /** @class */ (function () {
    function ThreeBounceComponent() {
        this.colorOne = '#00a65a';
        this.colorTwo = '#fdba2c';
        this.colorThree = '#da4733';
    }
    return ThreeBounceComponent;
}());
ThreeBounceComponent.decorators = [
    { type: Component, args: [{
                selector: 'mk-three-bounce',
                template: "\n    <div class=\"sk-three-bounce\">\n       <div class=\"sk-child sk-bounce1\" [style.background-color]=\"colorOne\"></div>\n       <div class=\"sk-child sk-bounce2\" [style.background-color]=\"colorTwo\"></div>\n       <div class=\"sk-child sk-bounce3\" [style.background-color]=\"colorThree\"></div>\n     </div>",
                styles: [".sk-three-bounce{margin:40px auto;width:80px;text-align:center}.sk-three-bounce .sk-child{width:20px;height:20px;background-color:#333;border-radius:100%;display:inline-block;-webkit-animation:1.4s ease-in-out infinite both sk-three-bounce;animation:1.4s ease-in-out infinite both sk-three-bounce}.sk-three-bounce .sk-bounce1{-webkit-animation-delay:-.32s;animation-delay:-.32s}.sk-three-bounce .sk-bounce2{-webkit-animation-delay:-.16s;animation-delay:-.16s}@-webkit-keyframes sk-three-bounce{0%,100%,80%{-webkit-transform:scale(0);transform:scale(0)}40%{-webkit-transform:scale(1);transform:scale(1)}}@keyframes sk-three-bounce{0%,100%,80%{-webkit-transform:scale(0);transform:scale(0)}40%{-webkit-transform:scale(1);transform:scale(1)}}"]
            },] },
];
ThreeBounceComponent.propDecorators = {
    "colorOne": [{ type: Input },],
    "colorTwo": [{ type: Input },],
    "colorThree": [{ type: Input },],
};
var ThreeBounceModule = /** @class */ (function () {
    function ThreeBounceModule() {
    }
    return ThreeBounceModule;
}());
ThreeBounceModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule
                ],
                declarations: [
                    ThreeBounceComponent,
                ],
                exports: [
                    ThreeBounceComponent
                ]
            },] },
];
var WanderingCubesComponent = /** @class */ (function () {
    function WanderingCubesComponent() {
        this.colorOne = '#da4733';
        this.colorTwo = '#3b78e7';
    }
    return WanderingCubesComponent;
}());
WanderingCubesComponent.decorators = [
    { type: Component, args: [{
                selector: 'mk-wandering-cubes',
                template: "\n    <div class=\"sk-wandering-cubes\">\n      <div class=\"sk-cube sk-cube1\" [style.background-color]=\"colorOne\"></div>\n      <div class=\"sk-cube sk-cube2\" [style.background-color]=\"colorTwo\"></div>\n    </div>",
                styles: [".sk-wandering-cubes{margin:40px auto;width:40px;height:40px;position:relative}.sk-wandering-cubes .sk-cube{width:10px;height:10px;position:absolute;top:0;left:0;-webkit-animation:1.8s ease-in-out -1.8s infinite both sk-wanderingCube;animation:1.8s ease-in-out -1.8s infinite both sk-wanderingCube}.sk-wandering-cubes .sk-cube2{-webkit-animation-delay:-.9s;animation-delay:-.9s}@-webkit-keyframes sk-wanderingCube{0%{-webkit-transform:rotate(0);transform:rotate(0)}25%{-webkit-transform:translateX(30px) rotate(-90deg) scale(.5);transform:translateX(30px) rotate(-90deg) scale(.5)}50%{-webkit-transform:translateX(30px) translateY(30px) rotate(-179deg);transform:translateX(30px) translateY(30px) rotate(-179deg)}50.1%{-webkit-transform:translateX(30px) translateY(30px) rotate(-180deg);transform:translateX(30px) translateY(30px) rotate(-180deg)}75%{-webkit-transform:translateX(0) translateY(30px) rotate(-270deg) scale(.5);transform:translateX(0) translateY(30px) rotate(-270deg) scale(.5)}100%{-webkit-transform:rotate(-360deg);transform:rotate(-360deg)}}@keyframes sk-wanderingCube{0%{-webkit-transform:rotate(0);transform:rotate(0)}25%{-webkit-transform:translateX(30px) rotate(-90deg) scale(.5);transform:translateX(30px) rotate(-90deg) scale(.5)}50%{-webkit-transform:translateX(30px) translateY(30px) rotate(-179deg);transform:translateX(30px) translateY(30px) rotate(-179deg)}50.1%{-webkit-transform:translateX(30px) translateY(30px) rotate(-180deg);transform:translateX(30px) translateY(30px) rotate(-180deg)}75%{-webkit-transform:translateX(0) translateY(30px) rotate(-270deg) scale(.5);transform:translateX(0) translateY(30px) rotate(-270deg) scale(.5)}100%{-webkit-transform:rotate(-360deg);transform:rotate(-360deg)}}"]
            },] },
];
WanderingCubesComponent.propDecorators = {
    "colorOne": [{ type: Input },],
    "colorTwo": [{ type: Input },],
};
var WanderingCubesModule = /** @class */ (function () {
    function WanderingCubesModule() {
    }
    return WanderingCubesModule;
}());
WanderingCubesModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule
                ],
                declarations: [
                    WanderingCubesComponent,
                ],
                exports: [
                    WanderingCubesComponent
                ]
            },] },
];
var WaveComponent = /** @class */ (function () {
    function WaveComponent() {
        this.color = '#da4733';
    }
    return WaveComponent;
}());
WaveComponent.decorators = [
    { type: Component, args: [{
                selector: 'mk-wave',
                template: "\n    <div class=\"sk-wave\">\n      <div class=\"sk-rect sk-rect1\" [style.background-color]=\"color\"></div>\n      <div class=\"sk-rect sk-rect2\" [style.background-color]=\"color\"></div>\n      <div class=\"sk-rect sk-rect3\" [style.background-color]=\"color\"></div>\n      <div class=\"sk-rect sk-rect4\" [style.background-color]=\"color\"></div>\n      <div class=\"sk-rect sk-rect5\" [style.background-color]=\"color\"></div>\n    </div>",
                styles: [".sk-wave{margin:40px auto;width:50px;height:40px;text-align:center;font-size:10px}.sk-wave .sk-rect{height:100%;width:6px;display:inline-block;-webkit-animation:1.2s ease-in-out infinite sk-waveStretchDelay;animation:1.2s ease-in-out infinite sk-waveStretchDelay}.sk-wave .sk-rect1{-webkit-animation-delay:-1.2s;animation-delay:-1.2s}.sk-wave .sk-rect2{-webkit-animation-delay:-1.1s;animation-delay:-1.1s}.sk-wave .sk-rect3{-webkit-animation-delay:-1s;animation-delay:-1s}.sk-wave .sk-rect4{-webkit-animation-delay:-.9s;animation-delay:-.9s}.sk-wave .sk-rect5{-webkit-animation-delay:-.8s;animation-delay:-.8s}@-webkit-keyframes sk-waveStretchDelay{0%,100%,40%{-webkit-transform:scaleY(.4);transform:scaleY(.4)}20%{-webkit-transform:scaleY(1);transform:scaleY(1)}}@keyframes sk-waveStretchDelay{0%,100%,40%{-webkit-transform:scaleY(.4);transform:scaleY(.4)}20%{-webkit-transform:scaleY(1);transform:scaleY(1)}}"]
            },] },
];
WaveComponent.propDecorators = {
    "color": [{ type: Input },],
};
var WaveModule = /** @class */ (function () {
    function WaveModule() {
    }
    return WaveModule;
}());
WaveModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule
                ],
                declarations: [
                    WaveComponent,
                ],
                exports: [
                    WaveComponent
                ]
            },] },
];

export { LoadingPageModule, LoadingPageDirective, HttpInterceptorService, HttpInterceptorServiceFactory, HttpObservableService, RouteInterceptorService, ChasingDotsModule, ChasingDotsComponent, CircleModule, CircleComponent, CubeGridModule, CubeGridComponent, DoubleBounceModule, DoubleBounceComponent, FadingCircleModule, FadingCircleComponent, FoldingCubeModule, FoldingCubeComponent, MaterialBarModule, MaterialbarComponent, PulseModule, PulseComponent, SlidingBarModule, SlidingBarComponent, ThreeBounceModule, ThreeBounceComponent, WanderingCubesModule, WanderingCubesComponent, WaveModule, WaveComponent };
//# sourceMappingURL=angular-loading-page.js.map
